module.exports = __webpack_public_path__ + "img/settings_it.642a1502.png";